module.exports = __webpack_public_path__ + "img/42_45.cd9b9b0e.png";